import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "py-3" }
const _hoisted_2 = { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }
const _hoisted_3 = {
  key: 0,
  class: "mt-2 text-sm text-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_field = _resolveComponent("input-field")!
  const _component_checkbox_input = _resolveComponent("checkbox-input")!
  const _component_json_editor_vue = _resolveComponent("json-editor-vue")!
  const _component_multi_json_input = _resolveComponent("multi-json-input")!
  const _component_tags_input = _resolveComponent("tags-input")!
  const _component_form_divider = _resolveComponent("form-divider")!
  const _component_button_wrapper = _resolveComponent("button-wrapper")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
  }, [
    _createVNode(_component_form_divider, null, {
      default: _withCtx(() => [
        _createVNode(_component_input_field, {
          modelValue: _ctx.formData.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
          errorMessage: _ctx.v$?.formData['name']?.$errors[0]?.$message,
          isError: _ctx.v$?.formData['name']?.$error,
          label: _ctx.$t('Integrations.Name'),
          required: true
        }, null, 8, ["modelValue", "errorMessage", "isError", "label"]),
        _createVNode(_component_checkbox_input, {
          modelValue: _ctx.formData.config.usePayloadFromResponse,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.config.usePayloadFromResponse) = $event)),
          "is-checked": _ctx.formData.config.usePayloadFromResponse,
          label: "Use payload from response"
        }, null, 8, ["modelValue", "is-checked"]),
        _createVNode(_component_input_field, {
          modelValue: _ctx.formData.config.daprAppId,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.config.daprAppId) = $event)),
          errorMessage: _ctx.v$?.formData['config'].daprAppId?.$errors[0]?.$message,
          isError: _ctx.v$?.formData['config'].daprAppId?.$error,
          label: 'App ID',
          required: true
        }, null, 8, ["modelValue", "errorMessage", "isError"]),
        _createVNode(_component_input_field, {
          modelValue: _ctx.formData.config.url,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.config.url) = $event)),
          errorMessage: _ctx.v$?.formData['config'].url?.$errors[0]?.$message,
          isError: _ctx.v$?.formData['config'].url?.$error,
          label: 'URL',
          required: true
        }, null, 8, ["modelValue", "errorMessage", "isError"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("label", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.$t("DeviceTypeMetadata.Data")), 1),
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "pl-0.5 text-orange-600" }, "*", -1))
          ]),
          _createVNode(_component_json_editor_vue, {
            modelValue: _ctx.formData.config.data,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.config.data) = $event)),
            "main-menu-bar": false,
            "status-bar": false,
            class: _normalizeClass(`mt-1 ${_ctx.v$?.formData['config'].data?.$error && 'error'}`),
            mode: "text"
          }, null, 8, ["modelValue", "class"]),
          (_ctx.v$?.formData['config'].data?.$error)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.v$?.formData["config"].data?.$errors[0]?.$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_multi_json_input, {
          onInput: _ctx.handleTopicChange,
          topics: _ctx.formData.config.topicToChannel
        }, null, 8, ["onInput", "topics"]),
        _createVNode(_component_tags_input, {
          label: _ctx.$t('Integrations.Channels'),
          tags: _ctx.formData.config.channels,
          onOnTagMutate: _cache[5] || (_cache[5] = (tags) => (_ctx.formData.config.channels = tags))
        }, null, 8, ["label", "tags"]),
        _createVNode(_component_input_field, {
          modelValue: _ctx.formData.executionOrder,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.executionOrder) = $event)),
          label: _ctx.$t('Integrations.ExecutionOrder'),
          type: "number"
        }, null, 8, ["modelValue", "label"]),
        _createVNode(_component_checkbox_input, {
          modelValue: _ctx.formData.isActive,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.isActive) = $event)),
          "is-checked": _ctx.formData.isActive,
          label: _ctx.$t('Integrations.Active')
        }, null, 8, ["modelValue", "is-checked", "label"])
      ]),
      _: 1
    }),
    _createVNode(_component_button_wrapper, { "is-submit-loading": _ctx.isSubmitLoading }, null, 8, ["is-submit-loading"])
  ], 32))
}